/*
==========================================
Custom JavaScript for Cart page
==========================================
*/

// Agreement checkbox
document.addEventListener("DOMContentLoaded", () => {
  const agreementList = document.querySelectorAll("[data-checkout_agreement]"),
    checkoutBtn = document.querySelector('button[name="checkout"]');

  if (agreementList.length > 0) {
    checkoutBtn.classList.add("is-disabled");
    agreementList.forEach((agreement) => {
      agreement.addEventListener("change", () => {
        let checked = 0;
        agreementList.forEach((agreement) => {
          if (agreement.checked) {
            checked++;
          }
        });
        if (checked === agreementList.length) {
          checkoutBtn.classList.remove("is-disabled");
        } else {
          checkoutBtn.classList.add("is-disabled");
        }

        // If reservation agreement is checked, set local storage
        if (agreement.id === "agreement") {
          if (agreement.checked) {
            localStorage.setItem("reservation_agreement", agreement.checked);
          } else {
            localStorage.removeItem("reservation_agreement");
          }
        }
      });
    });
  }

  // Check reservation agreement on page load
  const reservationAgreementCheckbox = document.getElementById("agreement");
  if (reservationAgreementCheckbox) {
    if (localStorage.getItem("reservation_agreement") === "true") {
      reservationAgreementCheckbox.checked = true;
      checkoutBtn.classList.remove("is-disabled");
    }
  }
});

// Modal
const openGiftModal = (_targetId) => {
  const modal = document.getElementById(_targetId);
  if (modal) {
    modal.setAttribute("open", true);
    document.documentElement.classList.add("lock-all");
  }
}
const closeGiftModal = (_targetId) => {
  const modal = document.getElementById(_targetId);
  if (modal) {
    modal.removeAttribute("open");
    document.documentElement.classList.remove("lock-all");
  }
}


// 2024.5.7 Add start : Sticky checkout button on mobile
//  画面内にチェックアウトボタンが表示されている場合は、画面スクロール時に非表示にする
//  (Mobile表示の場合のみ)
const checkoutButtonArea = document.getElementById("cart-ctas-area");

function isInViewport(element) {
  const rect = element.getBoundingClientRect();
  return (
    rect.top >= 0 &&
    rect.left >= 0 &&
    rect.bottom <= (document.documentElement.clientHeight) &&
    rect.right <= (document.documentElement.clientWidth)
  );
}

window.addEventListener("scroll", () => {
  checkoutButtonArea.style.minHeight = `${checkoutButtonArea.clientHeight}px`;
  if (isInViewport(checkoutButtonArea)) {
    checkoutButtonArea.querySelector("[data-floating]").setAttribute("data-floating", false);
  } else {
    checkoutButtonArea.querySelector("[data-floating]").setAttribute("data-floating", true);
  }
  document.querySelector("footer").style.setProperty('--floating-area-height', `${checkoutButtonArea.querySelector("[data-floating]").clientHeight}px`);
});
// 2024.5.7 Add end : Sticky checkout button

// 2025.4.2 Add start : Gift anker button
document.addEventListener("DOMContentLoaded", () => {
  const giftSelectArea = document.getElementById("gift-modal-button-block");
  if (giftSelectArea) {
    const cartPageHeader = document.querySelector(".c-cart-section .page-header__text-wrapper");
    cartPageHeader.insertAdjacentHTML("beforeend", `
      <div class="c-gift__anker-link-wrapper">
        <button type="button" data-smooth-scroll="gift-modal-button-block" class="c-gift__anker-link hidden-lap-and-up">
          ギフトでご利用のお客様はこちら  ↓
        </button>
      </div>
    `);
  }


  const selectElementList = document.querySelectorAll("[data-smooth-scroll]");

  selectElementList.forEach((element) => {
    element.addEventListener("click", function (event) {
      event.preventDefault();
      const selectedSectionId = this.getAttribute("data-smooth-scroll");
      if (selectedSectionId === "page-top") {
        window.scrollTo({ top: 0, behavior: "smooth", });
      } else {
        const sectionElement = document.querySelector(`#${selectedSectionId}`);

        if (sectionElement) {
          sectionElement.scrollIntoView({ behavior: "smooth" });
        }
      }
    });
  });
});
// 2025.4.2 Add end : Gift anker button
// -----------------------------
// 2026.8.30 Add start : Bulk remove line items
//   カート内の商品をチェックボックスで複数選択し、まとめて削除する
//   ・自動プレゼントワインの行は選択対象外（セクション側で自動追加・自動削除しているため）
//   ・ギフト包装で紐づく行（data-gift_id）は、同じ gift_id の行をまとめて選択・削除する
// -----------------------------
document.addEventListener("DOMContentLoaded", () => {
  const bulkRemoveArea = document.getElementById("cart-bulk-remove");
  const cartItemsTable = document.getElementById("cart-items-table");

  if (!bulkRemoveArea || !cartItemsTable) return;

  const selectAllCheckbox = document.getElementById("cart-bulk-remove-all");
  const removeButton = document.getElementById("cart-bulk-remove-button");
  const removeButtonText = removeButton.querySelector(".c-cart-bulk-remove__button-text");
  const removeButtonDefaultText = removeButtonText.textContent;

  // 選択可能な行（＝自動プレゼントワイン以外）
  const selectableRows = Array.from(
    cartItemsTable.querySelectorAll('.line-item[data-bulk_removable="true"]')
  );

  // 選択できる商品が1つもない場合はツールバーを出さない
  if (selectableRows.length === 0) return;
  bulkRemoveArea.removeAttribute("hidden");

  const checkboxOf = (row) => row.querySelector("[data-bulk_remove_item]");
  const checkedRows = () => selectableRows.filter((row) => checkboxOf(row).checked);

  // ギフト包装で紐づく行を、チェック状態ごと同期する
  const syncGiftGroup = (row) => {
    const giftId = row.getAttribute("data-gift_id");
    if (!giftId) return;

    const checked = checkboxOf(row).checked;
    selectableRows.forEach((targetRow) => {
      if (targetRow === row) return;
      if (targetRow.getAttribute("data-gift_id") !== giftId) return;
      checkboxOf(targetRow).checked = checked;
    });
  };

  // 「すべて選択」の状態・削除ボタンの活性/非活性を更新する
  const refreshState = () => {
    const selectedCount = checkedRows().length;

    selectAllCheckbox.checked = selectedCount === selectableRows.length;
    selectAllCheckbox.indeterminate = selectedCount > 0 && selectedCount < selectableRows.length;

    removeButton.disabled = selectedCount === 0;
    removeButtonText.textContent =
      selectedCount > 0
        ? `${removeButtonDefaultText}（${selectedCount}点）`
        : removeButtonDefaultText;

    selectableRows.forEach((row) => {
      row.classList.toggle("is-bulk-selected", checkboxOf(row).checked);
    });
  };

  selectableRows.forEach((row) => {
    checkboxOf(row).addEventListener("change", () => {
      syncGiftGroup(row);
      refreshState();
    });
  });

  selectAllCheckbox.addEventListener("change", () => {
    selectableRows.forEach((row) => {
      checkboxOf(row).checked = selectAllCheckbox.checked;
    });
    refreshState();
  });

  removeButton.addEventListener("click", () => {
    const targetRows = checkedRows();
    if (targetRows.length === 0) return;

    if (!window.confirm(`選択した${targetRows.length}点の商品をカートから削除します。よろしいですか？`)) {
      return;
    }

    // /cart/update.js は「ラインアイテムのkey : 数量」の形式でまとめて更新できる
    const updates = {};
    const deletedHandles = [];
    targetRows.forEach((row) => {
      updates[row.getAttribute("data-item_key")] = 0;
      deletedHandles.push(row.getAttribute("data-product_handle"));
    });

    // 二重送信・削除中の数量変更を防ぐ
    bulkRemoveArea.classList.add("is-loading");
    removeButton.disabled = true;
    selectAllCheckbox.disabled = true;
    selectableRows.forEach((row) => {
      checkboxOf(row).disabled = true;
    });
    document
      .querySelectorAll(".line-item__quantity")
      .forEach((quantity) => quantity.setAttribute("disabled", true));

    fetch("/cart/update.js", {
      method: "POST",
      headers: {
        dataType: "json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ updates: updates }),
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`Bulk remove failed: ${response.status}`);
        }
        return response.json();
      })
      .then(() => {
        window.dataLayer = window.dataLayer || [];
        deletedHandles.forEach((handle) => {
          dataLayer.push({
            event: "additional_cart",
            deleted_item_id: handle,
          });
        });
      })
      .catch((error) => {
        console.error("Error:", error);
        alert("カートの更新に失敗しました。ページを再表示します。");
      })
      .finally(() => {
        location.href = "/cart";
      });
  });

  refreshState();
});
// -----------------------------
// 2026.8.30 Add end : Bulk remove line items
// -----------------------------
